export enum AllowedPalletAction {
  Edit = 1,
  Issue = 2,
  Consume = 3,
  Delete = 5,
  Scrap = 6,
  Reprint = 7,
  AddDefect = 8,
  BlockAny = 9,
  BlockQi = 10,
  BlockResort = 11,
  BlockPackaging = 12,
  RemoveDefect = 14,
  Unblock = 15,
}
